import { createFileRoute } from "@tanstack/react-router";
import { ErrorAlert } from "@/components/ui";
import { ExpedientePage } from "@/features/revision-documental/components/ExpedientePage";
import { expedienteQueryOptions } from "@/features/revision-documental/hooks/use-revision-documental";

/**
 * Expediente documental de la solicitud (Gestión Documental · fase 3) · lo abren el solicitante,
 * quien tiene acceso a la solicitud y los revisores de alguno de sus documentos (el backend decide).
 */
export const Route = createFileRoute("/_authed-tw/solicitudes/$id/expediente")({
  loader: ({ context: { queryClient }, params: { id } }) => queryClient.ensureQueryData(expedienteQueryOptions(id)),
  component: ExpedientePage,
  errorComponent: ({ error }) => <ErrorAlert error={error} />,
});
